import React, { Component } from 'react';
import styles from './auth.module.scss';
import classnames from 'classnames';
import API, { VERIFICATION_VIA_EMAIL } from '../utils/API';
import { strings } from '../utils/translations';
import { Errors } from '../utils/errors';
import Loader from '../Loader/index';
import SixDigitInput from './sixDigitInput.js';
import PrimaryButton from '../Buttons/primaryButton';
import SecondaryButton from '../Buttons/secondaryButton';
import CloseIcon from '../../img/icons/closeIcon';
import moment from 'moment'
import { notification } from 'antd'

const SMS_TIMER_MAX = 120 // 120 seconds to wait to resend SMS

export default class VerifyNewDevice extends Component
{
    code = null
    focusSixDigitInput = true
    
    constructor(props)
    {
        super(props);
        
        this.state =
        {
            codeSent: false,
            deviceVerified: false,
            sendingCode: false,
            verifyingCode: false,
            twoFaVia: null,
            smsTimer: null,

            showDidntReceiveDialog: false,
            
            sendingCodeError: false,
            verifyingCodeError: false
        }
    }
    componentDidMount()
    {
        this.startNewDeviceVerification()
    }
    
    render()
    {
        const sendingView =
            <div>
                <Loader />
            </div>
        
        const title = <h3 className={styles.authTitle}>{ strings('verifyThisDevice') }</h3>
        const subtitle = (!this.state.deviceVerified && !this.state.sendingCode) ?
                            <div className={styles.verifyContainer}>
                                <p className={styles.descriptionText}>
                                {
                                    (this.state.sendingCode) ?
                                    strings('verifyingYourCode')
                                    :
                                    <>
                                        { strings('verifyThisDeviceText1') }
                                        { this.state.sendingCodeError ? null :
                                            <>
                                                { (this.state.twoFaVia === 'mail') ? `${strings('verifyThisDeviceText2Email')} ` : `${strings('verifyThisDeviceText2')} ` }
                                                <strong>{ (this.state.twoFaVia === 'mail') ? this.props.email : this.state.phone }</strong>
                                                { `${strings('verifyThisDeviceText3')}` }
                                            </>
                                        }
                                    </>
                                }
                                </p>
                            </div> : null;
                            
                        
        const didntReceiveDialog =
            <div className={styles.alternativeBox}>
                <PrimaryButton
                    text={  strings('resend') }
                    onClick={() =>
                    {
                        this.setState({ showDidntReceiveDialog: false })
                        this.startNewDeviceVerification()
                    }}
                />
                <SecondaryButton
                    text={ strings('cancel') }
                    onClick={() => this.setState({ showDidntReceiveDialog: false })}
                />
            </div>;
        
        const codeView =
            <>
                <div className={styles.box}>
                    <SixDigitInput
                        ref={ref => this.sixDigitInput = ref}
                        onCodeChanged={this.onCodeChanged.bind(this)}
                        onCodeFilled={this.onCodeFilled.bind(this)}
                    ></SixDigitInput>
                </div>
                
                {
                    (this.state.smsTimer != null) ?
                    <div className={styles.secondaryText}>
                        { `${strings('smsWaitingTimer')} ${this.state.smsTimer} ${strings('smsWaitingTimer2')}` }
                    </div>
                    :
                    <div onClick={() => this.setState({ showDidntReceiveDialog: true })}>
                        <p className={styles.secondaryText}>
                            <a className={styles.password}>{ strings('didntReceiveCode') }</a>
                        </p>
                    </div>
                }
                
                { 
                    this.state.showDidntReceiveDialog &&
                    didntReceiveDialog
                }
            </>
            
        const verifiedView = 
            <div className={styles.verifyContainer}>
                <p className={styles.descriptionText}>{ strings('verifyThisDeviceSuccess') }</p>
            </div>
        
            
        let view = null
        
        if (this.state.sendingCode || this.state.verifyingCode)
            view = sendingView
        else if (this.state.codeSent)
        {
            view = codeView
            
            if (this.state.deviceVerified)
                view = verifiedView
        }
        
        
        return (
            <>
                <div className={styles.titleContainer}>
                    { title }
                </div>
                { subtitle }
                
                { view }                        
            </>
        );
    }
    
    onCodeChanged(code)
    {
        this.code = code
        console.log(code)
    }
    onCodeFilled()
    {
        this.verifyNewDevice(this.code)
    }
    
    startNewDeviceVerification()
    {        
        this.setState({ sendingCode: true, sendingCodeError: false, codeSent: false }, () =>
        {
            API.getInstance().startNewDeviceVerification(this.props.email)
            .then(response =>
            {
                if (response.data.response != null &&
                    response.data.response.status != null &&
                    response.data.response.status)
                {
                    this.setState({
                        sendingCode: false,
                        codeSent: true,
                        phone: response.data.response.phone,
                        twoFaVia: response.data.response.twoFaVia
                    })
            
                    this.startSmsTimer()
                }
                else
                {
                    this.setState({
                        sendingCode: false,
                        sendingCodeError: true
                    }, () => { this.sixDigitInput?.clearCode() })
                    
                    notification.error(
                    {
                        description: (this.state.twoFaVia === 'mail') ? strings('errorSendingVerificationEmail') : strings('errorSendingVerificationSms'),
                        placement: 'top'
                    })
                }
            
                console.log(response);
            })
            .catch(error =>
            {    
                this.setState({
                    sendingCode: false,
                    sendingCodeError: true
                }, () => { this.sixDigitInput?.clearCode() })
            
                notification.error(
                {
                    description: (this.state.twoFaVia === 'mail') ? strings('errorSendingVerificationEmail') : strings('errorSendingVerificationSms'),
                    placement: 'top'
                })
            });
        });
    }
    verifyNewDevice(code)
    {
        this.setState({ verifyingCode: true, verifyingCodeError: false, deviceVerified: false }, () =>
        {
            API.getInstance().verifyNewDevice(this.props.email, code)
            .then(response =>
            {                            
                if (!response.data.status)
                {
                    this.setState({ verifyingCode: false, verifyingCodeError: true },
                        () => { this.sixDigitInput?.clearCode() })
                }
                else
                {
                    this.setState({ verifyingCode: false, deviceVerified: true }, () =>
                    {
                        setTimeout(() =>
                        {                            
                            if (this.props.onDeviceVerified != null)
                                this.props.onDeviceVerified()
                                
                        }, 2000);
                    });
                }
            })
            .catch(error =>
            {    
                this.setState({ verifyingCode: false, verifyingCodeError: true },
                    () => { this.sixDigitInput?.clearCode() })
                
                notification.error(
                {
                    description: Errors.showAppError(error),
                    placement: 'top'
                })
            });
        });
    }
    
    startSmsTimer()
    {
        const intervalFunction = () =>
        {
            if (this.smsTimerDuration == null)
                this.smsTimerDuration = moment.duration(SMS_TIMER_MAX, 'seconds')
            else
                this.smsTimerDuration = moment.duration(this.smsTimerDuration.asSeconds()-1, 'seconds')
            
            if (this.smsTimerDuration?.asSeconds() === 0)
            {
                this.setState({ smsTimer: null })
                this.smsTimerDuration = null
                clearInterval(this.smsTimer)
            }
            else
                this.setState({ smsTimer: moment(this.smsTimerDuration.asMilliseconds()).format('mm:ss') })
        }
        
        this.setState({ codeSent: true })
        
        intervalFunction()
        this.smsTimer = setInterval(intervalFunction, 1000)
    }
    
    close()
    {
        if (this.props.close != null)
            this.props.close()
    }
}